import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../hooks/useMainContext';
import { useEffect } from 'react';
import { ViewerMode } from '../../config';

let count = 0;

export const PageViewer = observer(({ viewerMode }) => {
    const { closetManager, viewManager, matrixManager } = useMainContext();

    useEffect(() => {
        const initialize = async () => {
            if (
                closetManager.pdfCanvasRef &&
                viewerMode === ViewerMode.ANNOTATE
            ) {
                if (count === 0) {
                    await closetManager.renderPage();
                    closetManager.loadSnappingPoints();
                    count++;
                }

                await closetManager.fitToScreen();
            }
            if (
                matrixManager.pdfCanvasRef &&
                viewerMode === ViewerMode.MATRIX
            ) {
                if (count === 0) {
                    await matrixManager.renderPage();
                    count++;
                }

                await matrixManager.fitToScreen();
            }
            if (viewManager.pdfCanvas && viewerMode === ViewerMode.VIEW) {
                viewManager.renderPage();
            }
        };
        initialize();
    }, []);

    return (
        <>
            {viewerMode === ViewerMode.ANNOTATE && (
                <canvas
                    className="pdf-canvas-annotationViewer"
                    style={{ position: 'absolute' }}
                    ref={(ref) =>
                        ref &&
                        closetManager.setPdfCanvasRef(ref) &&
                        closetManager.setDivRef(ref) &&
                        matrixManager.setDivRef(ref)
                    }
                />
            )}
            {viewerMode === ViewerMode.VIEW && (
                <canvas
                    className="pdf-canvas"
                    // style={{ position: 'absolute' }}
                    ref={(ref) =>
                        ref &&
                        viewManager.setPdfCanvas(ref) &&
                        closetManager.setDivRef(ref) &&
                        matrixManager.setDivRef(ref)
                    }
                />
            )}
            {viewerMode === ViewerMode.MATRIX && (
                <canvas
                    className="pdf-canvas-annotationViewer"
                    style={{ position: 'absolute' }}
                    ref={(ref) =>
                        ref &&
                        matrixManager.setPdfCanvasRef(ref) &&
                        matrixManager.setDivRef(ref)
                    }
                />
            )}
        </>
    );
});
